module.exports = __webpack_public_path__ + "static/assets/fa52c812315e75dcbd975ccaabd132d6.svg";